import React, { useState } from "react";
import styles from "./Slide1.module.scss";
import {
  RecordingRoomDiagram,
  RecordingRoomItem,
} from "@src/lms/jelly/extensions/layouts/_lesson/guide04/production/image/RecordingRoomDiagram";
import ProdRoom from "./prod_room.svg";
import ProdRoomAm from "./prod_room_am.svg";
import ProdRoomWms from "./prod_room_wms.svg";
import ProdRoomMs from "./prod_room_ms.svg";
import ProdRoomAr from "./prod_room_ar.svg";
import ProdRoomExtra from "./prod_room_extra.svg";

export const Slide1: React.FC = () => {
  const [selectedItem, setSelectedItem] = useState<RecordingRoomItem | null>(null);

  const handleItemSelect = (id: RecordingRoomItem | null): void => {
    setSelectedItem(id);
  };

  // Get the appropriate SVG component based on selected item
  const getCurrentSvgComponent = (): React.ComponentType => {
    switch (selectedItem) {
      case "am":
        return ProdRoomAm;
      case "wms":
        return ProdRoomWms;
      case "ms":
        return ProdRoomMs;
      case "ar":
        return ProdRoomAr;
      case "extra":
        return ProdRoomExtra;
      default:
        return ProdRoom; // Default overview
    }
  };

  // Get the diagram key for React reconciliation
  const getCurrentDiagramKey = (): string => {
    return selectedItem || "default";
  };

  return (
    <div className={styles.slide}>
      <RecordingRoomDiagram
        key={getCurrentDiagramKey()}
        diagramKey={getCurrentDiagramKey()}
        SvgComponent={getCurrentSvgComponent()}
        onItemSelect={handleItemSelect}
      />
    </div>
  );
};
